import {Component, ElementRef, OnDestroy, OnInit, ViewChild, input} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {ActivatedRoute, Router} from '@angular/router';

import * as fromProfile from './../../../profile/store/profile.reducers';
import * as fromApp from './../../../store/app.reducers';
import * as fromPayment from './../../store/payment.reducers';
import * as PaymentActions from './../../store/payment.actions';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-price-popup',
    templateUrl: './price-popup.component.html',
    styleUrls: ['./price-popup.component.scss'],
    standalone: false
})
export class PricePopupComponent implements OnInit, OnDestroy {

  readonly type = input<number>(undefined);
  profileState: Observable<fromProfile.State>;
  paymentState: Observable<fromPayment.State>;
  paymentSubscription: Subscription;
  id: number;
  @ViewChild('content', {static: true}) modal: ElementRef;
  options: number[] | string[];
  actualKey: number;

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.options = [];
    this.profileState = this.store.select('profile');
    this.paymentState = this.store.select('payment');

    this.id = +this.route.snapshot.params.id;

    this.paymentSubscription = this.store.select('payment').subscribe(
      (paymentState: fromPayment.State) => {
        this.options = Object.keys(paymentState.pricingProfile).map((value => parseInt(value))).sort();
        if (this.options.length) {
          this.setActualKey(this.options[0]);
        }
      }
    );

  }

  onLoadPricing() {
    this.store.dispatch(
      new PaymentActions.GetPricingProfile(this.id)
    );
  }

  open() {
    this.onLoadPricing();
    this.modalService.open(this.modal, {size: 'xl', centered: true}).result.then((result) => {
      // console.log('close modal');
    }, (reason) => {

    });
  }

  setActualKey(key: number) {
    this.actualKey = key; // key.toString() + '.00';
    // console.log(this.actualKey);
  }

  getValues(object: any) {
    return Object.values(object);
  }

  ngOnDestroy(): void {
    this.paymentSubscription.unsubscribe();
  }
}
